import React, { useState, useEffect } from "react";
import { Table } from "../../components/Table/Table";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { CaretLeft } from "../../assets/img";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

export default function UserFailedNotesTransaction() {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");

  const mode = location.state?.mode ?? "view";
  const id = location.state?.id ?? "";
  const data = location.state?.data ?? {};

  const [isViewMode, setIsViewMode] = useState(mode === "view");
  const [pagination, setPagination] = useState({});
  const [name, setName] = useState({});
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [transactions, setTransactions] = useState(data?.transactions || []);
  const [note, setNote] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    let userName = JSON.parse(localStorage.getItem("admin_details"));
    setName(userName);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          const pageSize = 10;
          return (
            <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
            </div>
          );
        },
      },
      {
        Header: "Transaction ID",
        accessor: "transaction_id",
        Cell: ({ value }) => (
          <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
            <p>{value}</p>
          </div>
        ),
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value }) => (
          <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
            <p>{value}</p>
          </div>
        ),
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (
          <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
            <p>{value}</p>
          </div>
        ),
      },
      {
        Header: "Payment Type",
        accessor: "payment_type",
        Cell: ({ value }) => (
          <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
            <p>{value}</p>
          </div>
        ),
      },
    ],
    [page],
  );

  const transactionFailed = async ({ id }) => {
    try {
      const res = await get(`${URLS.USER_FAILED_TRANSACTION_DETAILS}${id}`);
      console.log("RESPONSE:", res);

      if (res?.status === "success") {
        setTransactions(res?.data?.transactions);
        // setIsViewMode(!res?.data?.is_read); // ✅ properly updates state
        setNote(res?.data?.notes);
      }
    } catch (err) {
      console.log("ERROR:", err);
    }
  };

  useEffect(() => {
    transactionFailed({ id });
  }, [id]);
  useEffect(() => {
    setIsViewMode(location.state?.mode == "view");
  }, [location.state?.mode]);
  const handlerNotes = async () => {
    try {
      let pay = {
        alert_id: id,
        notes: note,
      };

      const res = await post(URLS.USER_FAILED_TRANSACTION_MARKREAD, pay);
      console.log("RESPONSE:", res);

      if (res.status == "success") {
        toast.success("Successfully Updated Notes");
        setIsViewMode(res?.data?.is_read); // ✅ properly updates state
        transactionFailed({ id });
      }
    } catch (err) {
      console.log("ERROR", err);
    }
  };
  console.log("isViewMode", isViewMode, location.state?.mode);

  return (
    <div>
      <Topbar
        header={"Failed Transaction"}
        subHead={isViewMode ? "View Notes" : "Add Notes"}
      />

      <div
        onClick={() =>
          navigate("/failed_transaction", {
            state: { activeTab: "User failed Transactions" },
          })
        }
        style={{
          background: "#78788029",
          flexDirection: "row",
          alignItems: "center",
          display: "flex",
          width: "90px",
          padding: "10px",
          borderRadius: "10px",
          cursor: "pointer",
        }}
      >
        <div style={{ width: 25, height: 25 }}>
          <img
            src={CaretLeft}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>
        <p>Back</p>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          flex: 1,
          gap: 20,
          alignItems: "baseline",
        }}
      >
        <div style={{ width: "50%" }}>
          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={transactions}
            show={false}
          />
        </div>

        <div style={{ width: "40%", transform: "translateY(-10px)" }}>
          <div
            style={{
              background: "#f3f4f6",
              borderRadius: "12px",
              padding: "1.5rem",
            }}
          >
            <h2
              style={{ fontSize: "16px", fontWeight: 500, margin: "0 0 1rem" }}
            >
              {isViewMode ? "View Notes" : "Add Notes"}
            </h2>

            <div
              style={{
                background: isViewMode ? "#f9fafb" : "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "12px 14px",
              }}
            >
              <textarea
                value={note}
                onChange={(e) => !isViewMode && setNote(e.target.value)}
                placeholder="No available balance in the account"
                rows={4}
                disabled={isViewMode}
                style={{
                  width: "100%",
                  border: "none",
                  outline: "none",
                  resize: "none",
                  fontSize: "14px",
                  color: isViewMode ? "#6b7280" : "#111827",
                  background: "transparent",
                  fontFamily: "inherit",
                  boxSizing: "border-box",
                  cursor: isViewMode ? "not-allowed" : "text",
                }}
              />
              <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>
                {name?.name} &nbsp;|&nbsp; ID: {name?.admin_code}
              </p>
            </div>

            {!isViewMode && checkPermission("CAN-EDIT-FAILED_TRANSACTION") && (
              <button
                style={{
                  marginTop: "1rem",
                  background: "#a78bfa",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 22px",
                  fontSize: "14px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.background = "#7c3aed")}
                onMouseOut={(e) => (e.target.style.background = "#a78bfa")}
                onClick={() => handlerNotes()}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
